import { ITableService } from 'src/app/common/interfaces/table/table-service.interface';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { IReturnList } from '../../interfaces/return-list/return-list.interface';
import { IReturnDecision } from '../../interfaces/return-list/return-decision.interface';

export abstract class AbstractRtpReturnListService extends ITableService {
  abstract returnRequestList(): Promise<any>;
  abstract getById(rtpUniqueMessageId: string): Promise<any>;
  abstract reasonDenyList(): Promise<any>;
  abstract returnStatusList(): Promise<any>;
  abstract paymentChannelList(): Promise<any>;
  abstract decisionSubmit(decision: IReturnDecision): Promise<IWebMessage | undefined>;
}
